import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

export const submitRSVP = (data) => api.post('/rsvp', data).then(r => r.data);
export const submitVisitor = (data) => api.post('/visitor', data).then(r => r.data);
export const submitNextStep = (data) => api.post('/next-steps', data).then(r => r.data);
export const submitPrayer = (data) => api.post('/prayer', data).then(r => r.data);
export const fetchPrayers = (since) => api.get('/prayers', { params: since ? { since } : {} }).then(r => r.data);
export const prayFor = (id) => api.post(`/prayers/${id}/pray`).then(r => r.data);
